/**
 * Video banner (sections/section-video.liquid) background video.
 *
 * The Liquid renders a single <video data-bg-video> with NO <source> children and
 * preload="none", plus two data attributes holding the desktop and mobile source sets
 * (data-sources-desktop / data-sources-mobile). This script picks the set matching the
 * current viewport, injects only those <source>s, and autoplays the video muted/looped.
 * Because sources are injected at runtime, only ONE video is ever downloaded.
 *
 * Playback is skipped entirely when the user prefers reduced motion, leaving the image
 * poster/base layer visible. If autoplay is blocked by the browser, the poster remains too.
 */
(function () {
  'use strict';

  // Run the setup once, no matter how many section instances include this asset.
  if (window.__sectionVideoBannerInit) {
    return;
  }
  window.__sectionVideoBannerInit = true;

  var VIDEO_SELECTOR = '[data-section-type="video"] .section-video__video[data-bg-video]';
  var INIT_ATTR = 'data-vb-initialized';

  function prefersReducedMotion() {
    return (
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function isMobileViewport() {
    var t = window.theme;
    var breakpoint = (t && t.sizes && t.sizes.medium) || 768;
    return window.matchMedia('(max-width: ' + (breakpoint - 1) + 'px)').matches;
  }

  function parseSources(raw) {
    if (!raw) {
      return [];
    }
    try {
      return JSON.parse(raw);
    } catch {
      return [];
    }
  }

  function activate(video) {
    if (video.getAttribute(INIT_ATTR) === 'true') {
      return;
    }

    var mobile = isMobileViewport();
    var sources = parseSources(
      video.getAttribute(mobile ? 'data-sources-mobile' : 'data-sources-desktop')
    );

    // Fall back to the other viewport's set (e.g. mobile with no mobile video).
    if (!sources.length) {
      sources = parseSources(
        video.getAttribute(mobile ? 'data-sources-desktop' : 'data-sources-mobile')
      );
    }

    if (!sources.length) {
      return;
    }

    // Prefer MP4: HLS (.m3u8) only plays natively in Safari, so a plain <source>
    // set to it fails silently in most browsers. MP4 is universally supported.
    var mp4Sources = sources.filter(function (item) {
      return item && item.type === 'video/mp4';
    });
    if (mp4Sources.length) {
      sources = mp4Sources;
    }

    video.setAttribute(INIT_ATTR, 'true');

    sources.forEach(function (item) {
      if (!item || !item.url) {
        return;
      }
      var source = document.createElement('source');
      source.src = item.url;
      if (item.type) {
        source.type = item.type;
      }
      video.appendChild(source);
    });

    // Muted is required for autoplay to be allowed.
    video.muted = true;
    video.preload = 'auto';
    video.load();

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        // Autoplay blocked — the image poster/base layer stays visible.
      });
    }
  }

  function init(root) {
    // Respect reduced-motion: never start playback; the poster/image remains.
    if (prefersReducedMotion()) {
      return;
    }
    var scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    var videos = scope.querySelectorAll(VIDEO_SELECTOR);
    Array.prototype.forEach.call(videos, activate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Theme editor: initialize sections added or reloaded in the customizer.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();
